/* eslint-disable no-prototype-builtins */
import { initializeFullStory } from "./main-helper";

initializeFullStory();
bootstrapAngular();

function bootstrapAngular() {
  // TODO: check if this can be removed
  const waitForZone = async () => {
    while (!window.hasOwnProperty("Zone")) {
      await new Promise((resolve) => setTimeout(resolve, 10));
    }
  };
  const bootstrapApp = async () => {
    await waitForZone();
    await import("./bootstrap");
  };

  void bootstrapApp();
}